import { j as l } from "./jsx-runtime.DGlMoOmv.js";
import * as w from "react";
import { c as u } from "./index.CxSWpsOB.js";
import { c as x } from "./index.C4-GUKyp.js";
const i = ["div", "p", "h1", "h2", "h3", "h4", "h5", "h6", "section", "article", "aside", "header", "footer", "nav", "figure", "figcaption", "blockquote", "pre", "ol", "ul", "li", "main", "table", "thead", "tbody", "tfoot", "tr", "th", "td", "form", "fieldset", "legend", "address", "details", "summary", "canvas", "output", "video", "audio"], e = ["span", "a", "strong", "em", "abbr", "cite", "code", "b", "i", "sub", "sup", "mark", "q", "time", "var", "s", "u", "small", "br", "wbr", "data", "label", "kbd", "bdo", "bdi"], b = x("", {
  variants: {
    spacing: {
      4: "tw-gap-4",
      6: "tw-gap-6",
      8: "tw-gap-8",
      12: "tw-gap-12",
      16: "tw-gap-16",
      20: "tw-gap-20",
      24: "tw-gap-24",
      28: "tw-gap-28",
      32: "tw-gap-32"
    },
    prefix: {
      true: "",
      false: ""
    },
    suffix: {
      true: "",
      false: ""
    },
    element: [...i, ...e].reduce((t, a) => ({
      ...t,
      [a]: ""
    }), {})
  },
  compoundVariants: [{
    element: e,
    class: "tw-inline-block"
    // this forces line height to be respected
  }, {
    element: e,
    prefix: !0,
    class: "tw-inline-flex tw-items-center"
  }, {
    element: e,
    suffix: !0,
    class: "tw-inline-flex tw-items-center"
  }, {
    element: i,
    prefix: !0,
    class: "tw-flex tw-items-center"
  }, {
    element: i,
    suffix: !0,
    class: "tw-flex tw-items-center"
  }]
}), g = ({
  className: t,
  children: a,
  element: o,
  typeface: c = "body-2",
  prefix: s,
  suffix: n,
  spacing: m = 8,
  testId: p,
  ...d
}, f) => {
  const r = o || "span";
  return /* @__PURE__ */ l.jsxs(r, { ref: f, "data-testid": p, className: u(`tw-${c}`, b({
    prefix: !!s,
    suffix: !!n,
    element: r,
    spacing: m,
    className: t
  })), ...d, children: [
    s && /* @__PURE__ */ l.jsx("span", { className: "tw-flex-none tw-inline-flex", children: s }),
    a,
    n && /* @__PURE__ */ l.jsx("span", { className: "tw-flex-none tw-inline-flex", children: n })
  ] });
}, h = w.forwardRef(g);
h.displayName = "Text";
export {
  h as T
};
//# sourceMappingURL=Text.BGhoO_e3.js.map
